import document from './document';

const bill = `
    amount
    created
    docIDBill
    document {
        ${document}
    }
    id
    ignored
    isBruttoBill
    positions {
        date
        description
        sum
    }
    referenceId
    referenceType
    sales
    type
`;

export default bill;
